export default __webpack_public_path__ + "static/media/Icon6.1e4098e1.svg";